var render = function render(){var _vm=this,_c=_vm._self._c;return (!this.$store.state.loadingChartData)?_c('div',{attrs:{"loading":this.$store.state.loadingChartData}},[_c('canvas',{staticStyle:{"max-height":"35rem"},attrs:{"id":"economicChart","loading":this.$store.state.loadingChartData}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }